import {
    categoryCodeToReadableTag,
    EVENTBRITE_FORMAT_MAPPING_PLURAL,
} from '@eventbrite/categories';
import React from 'react';
import { EventSearchInterfaceName } from '../../../../api/searchAllEvents';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { useRouteContext } from '../../context';
import { useBaseEventsQueryTagsAgg } from '../../hooks/queries/aggregations';
import { CategoryBrowseEvents } from '../CategoryBrowseEvents';

interface CategoryBrowseDynamicFormatEventsProps {
    queryOverload?: OrganicEventSearchFiltersApiPayload;
    bucketName: EventSearchInterfaceName;
    bucketNumber: number;
    bucketPosition?: string;
    includeHyperlinks?: boolean;
    affCode?: string;
    adSlots?: Array<number>;
}

export const CategoryBrowseDynamicFormatEvents: React.FunctionComponent<
    CategoryBrowseDynamicFormatEventsProps
> = ({
    bucketName,
    bucketNumber,
    bucketPosition,
    includeHyperlinks = true,
    queryOverload,
    affCode,
    adSlots = [],
}) => {
    const { data } = useBaseEventsQueryTagsAgg();
    const { parsedValues } = useRouteContext();
    const activeTag = parsedValues?.activeTag || '';

    if (!data) {
        return null;
    }

    const eligibleFormats = Object.keys(data).filter(
        (item) =>
            item !== 'EventbriteFormat/100' &&
            item.includes('EventbriteFormat') &&
            (data?.[item]?.doc_count || 0) > 3,
    );

    const format = eligibleFormats[bucketNumber];

    if (!format || !EVENTBRITE_FORMAT_MAPPING_PLURAL[format]) {
        return null;
    }
    queryOverload = {
        ...queryOverload,
        page_size: 8,
        tags: [activeTag, format],
        aggs: {},
    };

    return (
        <CategoryBrowseEvents
            lazyLoadCarouselElements={true}
            queryOverload={queryOverload}
            title={EVENTBRITE_FORMAT_MAPPING_PLURAL[format]}
            adSlots={adSlots}
            bucketName={bucketName}
            bucketKey={categoryCodeToReadableTag(format) || format}
            bucketPosition={bucketPosition}
            includeHyperlinks={includeHyperlinks}
            affCode={affCode}
        />
    );
};
